export default "/images/app-store-badge.e62cbd22.png";